// auto-direction.directive.ts
import { Directive, HostListener, ElementRef, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appAutoDirection]'
})
export class AutoDirectionDirective {
  constructor(private el: ElementRef, private renderer: Renderer2) {}

  @HostListener('input', ['$event.target.value'])
  onInput(value: string) {
    const direction = this.detectDirection(value);
    this.renderer.setStyle(this.el.nativeElement, 'direction', direction);
    this.renderer.setStyle(this.el.nativeElement, 'text-align', direction === 'rtl' ? 'right' : 'left');
  }

  private detectDirection(text: string): 'rtl' | 'ltr' {
    const firstStrongChar = text.match(/[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF]/); // Arabic character ranges
    return firstStrongChar ? 'rtl' : 'ltr';
  }
}
